<template>
  <div id="contract-renew">
    <b-row>
      <b-col cols="6">
        <div class="label">{{ $t('NEW_CONTRACT') }} - {{ label }}</div>
      </b-col>
      <b-col cols="1"></b-col>
      <b-col cols="5">
        <step-progress v-model="step" :steps="steps"/>
      </b-col>
    </b-row>
    <window-stepper @cancel="cancel" class="content" v-model="componentStep" :steps="componentSteps"/>
  </div>
</template>

<script>
import { computed, onMounted, onUnmounted, ref, watch } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import StepProgress from '@/components/StepProgress';
import WindowStepper from '@/components/WindowStepper';

import ClientStep from './StepComponents/ClientStep';
import AssetStep from './StepComponents/AssetStep';
import AuthorizedStep from './StepComponents/AuthorizedStep';
import RealestateStep from './StepComponents/RealestateStep';
import ContractStep from './StepComponents/ContractStep';
import CheckStep from './StepComponents/CheckStep';
import PrintStep from './StepComponents/PrintStep';
import CompleteStep from './StepComponents/CompleteStep';

const steps = ['Bước 1', 'Bước 2', 'Bước 3', 'Bước 4'];

const { useState, useActions } = createNamespacedHelpers('contractNew');
const { useState: useAppState, useActions: useAppActions } = createNamespacedHelpers('app');

export default {
  name: 'ContractNew',
  components: {
    StepProgress,
    WindowStepper,
  },
  metaInfo() {
    const { $i18n } = this;

    const title = $i18n.t('CREATE_CONTRACT');

    return {
      title,
      meta: []
    };
  },
  setup(_, { root }) {
    const { order } = useState(['order']);
    const { assetTypes } = useAppState(['assetTypes']);
    const { getValidators } = useAppActions(['getValidators']);

    const componentStep = ref(1);


    const componentSteps = computed(() => {
      const assetType = assetTypes.value.find((item) => item.description === order.value.assetType);

      if (assetType) {
        switch(assetType.name) {
          case 'Bike':
          case 'Car':
          case 'Truck':
            return [ClientStep, AuthorizedStep, AssetStep, ContractStep, CheckStep, PrintStep, CompleteStep];
          case 'Realestate':
            return [ClientStep, AssetStep, RealestateStep, ContractStep, CheckStep, PrintStep, CompleteStep];
          default:
            return [ClientStep, AssetStep, ContractStep, CheckStep, PrintStep, CompleteStep];
        }
      }
      return [ClientStep];
    });

    const { getOrderFromId, getProducts, reset } = useActions(['getOrderFromId', 'getProducts', 'reset']);

    const step = computed(() => {
      if (componentSteps.value.length > 6) {
        if (componentStep.value >= 5) {
          return componentStep.value - 2;
        }
        if (componentStep.value >= 3) {
          return componentStep.value - 1;
        }
      }
      if (componentStep.value >= 4) {
        return componentStep.value - 2;
      }
      return componentStep.value;
    });

    const label = computed(() => {
      if (step.value === 1) {
        return root.$t('CLNT_INFO');
      }

      if (step.value === 2) {
        return root.$t('COLLATERAL_INFO');
      }

      if (step.value === 3) {
        return root.$t('CNTRCT_INFO');
      }

      return root.$t('CONFIRM');
    });


    watch(step, () => window.scrollTo(0, 0));

    const cancel = () => {
      root.$router.back();
    };

    onMounted(() => {
      const id = root.$route.query.orderId;
      getOrderFromId(id);
      getProducts();
      getValidators();
    });

    onUnmounted(reset);

    return {
      steps,
      componentStep,
      step,
      componentSteps,
      label,
      cancel,
    };
  },
};
</script>

<style lang='scss' scoped>
@import "~@/assets/scss/colors";

#contract-renew {
  padding: 32px 30px;
  .label {
    font-size: 28px;
    text-transform: capitalize;
    color: $independence;
  }

  .content {
    margin-top: 48px;
  }
};
</style>
